import camelcase from 'camelcase-web'
import Less from '!less-var-to-js-loader!@/styles/variable.less'

const variables = {}
Object.keys(Less).forEach(k => variables[camelcase(k)] = Less[k])

// 静态使用
export { variables }

// 实现js访问less变量
export default function(Vue, options = {}) {
	var { state = {}, store } = options

	// check
	if (!store) {
		throw new Error("必需先创建store实例")
	}

	// 注册store.app模块
	store.registerModule('lessVars', {
		state: {
			variables: variables,
		},

		mutations: {
			setVariables(state, vars) {
				state.variables = vars || {}
			},

			mergeVariables(state, vars) {
				Object.assign(state.variables, vars)
			},
		},
	})

	// 配套混入
	Vue.mixin({
		computed: {
			$lvs() {
				return this.$store.state.lessVars.variables
			},

			// depreciated 
			variables() {
				return this.$lvs
			},

			// cssClass 前缀
			preCls() {
				return this.variables.cssPrefix
			}
		},
	})
}